import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Collection from "@/components/Collection";
import Story from "@/components/Story";
import Footer from "@/components/Footer";
import KeptFlame from "@/pages/CompanionTree";
import EssayPage from "@/pages/EssayPage";
import Admin from "@/pages/Admin";
import ComingSoon from "@/components/ComingSoon";

const GRAIN =
  "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 250 250' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.7' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")";

const Home = () => (
  <>
    <Hero />
    <Collection />
    <Story />
    <Footer />
  </>
);

const Shell = ({ children }) => (
  <>
    <Nav />
    <main>{children}</main>
  </>
);

// ─── LAUNCH SWITCH ───────────────────────────────────────────────
// COMING_SOON = true  → every public page shows the Coming Soon screen.
// COMING_SOON = false → the full site (home + The Companion Tree) returns.
// The admin at /admin stays reachable either way.
const COMING_SOON = true;

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-navy text-cream font-poppins overflow-x-clip">
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 z-[60] opacity-[0.05] mix-blend-overlay"
        style={{ backgroundImage: GRAIN }}
      />
      <BrowserRouter>
        <ScrollToTop />
        {COMING_SOON ? (
          <Routes>
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<ComingSoon />} />
          </Routes>
        ) : (
          <Routes>
            <Route path="/" element={<Shell><Home /></Shell>} />
            <Route path="/companion-tree" element={<Shell><KeptFlame /></Shell>} />
            <Route path="/companion-tree/:slug" element={<Shell><EssayPage /></Shell>} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        )}
      </BrowserRouter>
    </div>
  );
}

export default App;
